var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.status?.color)?_c('span',{staticClass:"__status-dots",style:({ backgroundColor: _vm.item.status.color })}):_vm._e(),_c('span',{staticClass:"mc-text-status"},[_vm._v(_vm._s(_vm.computedStatus(_vm.item.status.raw_type)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }